export default __webpack_public_path__ + "static/media/logo.016e87f1.svg";